import React from 'react'

import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

export const EmotionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const ref = React.useRef<HTMLDivElement>(null)
  const [shadowRoot, setShadowRoot] = React.useState<ShadowRoot | HTMLElement | null>(null)

  React.useLayoutEffect(() => {
    if (!ref.current) return
    const rootNode = ref.current.getRootNode()
    if (rootNode instanceof ShadowRoot) {
      setShadowRoot(rootNode)
    } else {
      setShadowRoot(document.body)
    }
  }, [])

  const cache = React.useMemo(
    () => (shadowRoot ? createCache({ key: 'react-select', container: shadowRoot }) : undefined),
    [shadowRoot]
  )

  if (!cache) return <div ref={ref} /> // Wait for shadowRoot

  return (
    <CacheProvider value={cache}>
      <div id="emotion-cache-provider" ref={ref}>
        {children}
      </div>
    </CacheProvider>
  )
}
